import type { GetCalendarProviderAccountsResponse } from '../types/GetCalendarProviderAccountsResponse';
import { makeGetRequest } from 'owa-ows-gateway';
import { logUsage } from 'owa-analytics';
import { isSuccessStatusCode } from 'owa-http-status-codes';

const GET_CALENDAR_PROVIDER_ACCOUNTS_URL = 'ows/api/beta/calendarProviderAccounts';

export function getCalendarProviderAccounts(): Promise<GetCalendarProviderAccountsResponse> {
    return makeGetRequest(
        GET_CALENDAR_PROVIDER_ACCOUNTS_URL,
        undefined /*correlationId*/,
        true /*returnFullResponse*/,
        undefined /*customHeaders*/,
        true /*throwServiceError*/
    )
        .then((response: Response & GetCalendarProviderAccountsResponse) => {
            logServiceResponse(
                isSuccessStatusCode(response.status),
                response.status.toString(),
                null
            );

            return response.json();
        })
        .catch(err => {
            logServiceResponse(false, null, JSON.stringify(err));
            return null;
        }) as Promise<GetCalendarProviderAccountsResponse>;
}

function logServiceResponse(isSuccess: boolean, status: string, error: string) {
    logUsage('calendarProviderAccounts_serviceResponse', {
        error: error,
        isSuccess_1: isSuccess,
        status_2: status,
    });
}
